import { AuthenticatedRouteComponent } from '../AuthenticatedRoute';
import { Slugs } from './knownSlugs';
import BuildingInfoPage from '../pages/my-building/BuildingInfoPage';
import AgreementPage from '../pages/AgreementPage';
import PaymentPage from '../pages/PaymentPage';
import DebtPage from '../pages/debt/DebtPage';
import BillingPage from '../pages/billing/BillingPage';
import ContactPage from '../pages/contact/ContactPage';
import NoticeListPage from '../pages/my-building/NoticeListPage';
import NoticePage from '../pages/my-building/NoticePage';
import ResidentCommitteePage from '../pages/ResidentCommitteePage';
import BuildingEventsPage from '../pages/my-building/BuildingEvents';
import EventPage from '../pages/my-building/EventPage';
import GuidesAndDocumentsPage from '../pages/my-building/GuidesAndDocumentsPage';
import PublicEventsPage from '../pages/PublicEventsPage';
import DefectNoticePage from '../pages/defect-notice/DefectNoticePage';

/* The key is a WordPress page slug for a page containing React content.
  Every page visible in the menu has at least a placeholder page in WordPress.
  If a menu item fetched from WordPress has a slug present in this list, we map
  it to the corresponding React component instead of using general WordPressPage component. */
export const reactPageSlugs: { [key: string]: AuthenticatedRouteComponent } = {
  // Vuokrani
  [Slugs.AGREEMENT]: AgreementPage,
  [`${Slugs.AGREEMENT}-eng`]: AgreementPage,
  [Slugs.BILLING]: BillingPage,
  [`${Slugs.BILLING}-eng`]: BillingPage,
  [Slugs.PAYMENT]: PaymentPage,
  [`${Slugs.PAYMENT}-eng`]: PaymentPage,
  [Slugs.DEBT]: DebtPage,
  [`${Slugs.DEBT}-eng`]: DebtPage,
  [Slugs.NOTICES]: NoticeListPage,
  [`${Slugs.NOTICES}-eng`]: NoticeListPage,
  // Varaukseni
  // [Slugs.BOOKING_CALENDAR]: HousingBookingsCalendar,
  // [`${Slugs.BOOKING_CALENDAR}-eng`]: HousingBookingsCalendar,
  // Taloni
  [Slugs.BUILDING_INFO]: BuildingInfoPage,
  [`${Slugs.BUILDING_INFO}-eng`]: BuildingInfoPage,
  [Slugs.GUIDES_DOCUMENTS]: GuidesAndDocumentsPage,
  [`${Slugs.GUIDES_DOCUMENTS}-eng`]: GuidesAndDocumentsPage,
  [Slugs.EVENTS]: BuildingEventsPage,
  [`${Slugs.EVENTS}-eng`]: BuildingEventsPage,
  // Asuminen
  [Slugs.EVENTS_FOR_ALL]: PublicEventsPage,
  [`${Slugs.EVENTS_FOR_ALL}-eng`]: PublicEventsPage,
  [Slugs.FAULT_REPORT]: DefectNoticePage,
  [`${Slugs.FAULT_REPORT}-eng`]: DefectNoticePage,
  // [Slugs.APARTMENT_CHANGE]: ApartmentChangePage,
  // [`${Slugs.APARTMENT_CHANGE}-eng`]: ApartmentChangePage,
  // [Slugs.NEW_APPLICATION]: ApartmentNewApplicationPage,
  // [`${Slugs.NEW_APPLICATION}-eng`]: ApartmentNewApplicationPage,
  [Slugs.COMMITTEE]: ResidentCommitteePage,
  [`${Slugs.COMMITTEE}-eng`]: ResidentCommitteePage,
  // Ota yhteyttä
  [Slugs.CONTACT_INFO]: ContactPage,
  [`${Slugs.CONTACT_INFO}-eng`]: ContactPage,
};

/**
 * Slugs from Wordpress which we know can have a dynamic subroute
 * i.e. /tiedotteet/{id-goes-here}.
 */
export const dynamicPathSlugs: { [key: string]: AuthenticatedRouteComponent } = {
  [Slugs.NOTICES]: NoticePage,
  [`${Slugs.NOTICES}-eng`]: NoticePage,
  [Slugs.EVENTS]: EventPage,
  [`${Slugs.EVENTS}-eng`]: EventPage,
};
